import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_KEY, SINGLE_PHOTO_URL } from "../../utils/topic-endpoints";

export const getSingleImageData = createAsyncThunk(
  "collectionImages/getSingleImageData",
  async (id, { rejectWithValue }) => {
    const url = SINGLE_PHOTO_URL + `/${id}/?client_id=${API_KEY}`;
    const response = await fetch(url);
    const data = await response.json();
    if (!response.ok) {
      const err = data.errors[0];
      return rejectWithValue(err);
    }
    return {
      imageId: id,
      imageDetails: data,
    };
  }
);
